export default "__VITE_ASSET__DaF3sO5q__"